export { default } from './PerformanceGraph';



// WEBPACK FOOTER //
// ./src/components/DataCentre/PerformanceGraph/index.ts